export enum JetOrderOption {
    ASC = 'asc',
    DESC = 'desc'
}
